var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIntelbrasVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 785.1 152.3",
    style: {
      enableBackground: "new 0 0 785.1 152.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;fill-opacity:0;}\r\n\t.st1{fill:#0D9A48;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: -44.6,
    className: "st0",
    width: 784.8,
    height: 255.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M627.7,36.7c-31.8,0-57.5,25.8-57.5,57.5c0,31.8,25.8,57.5,57.5,57.5c10.5,0,20.3-2.8,28.8-7.7v7.7h28.8V94.2 C685.2,62.4,659.5,36.7,627.7,36.7z M656.5,94.2v0.3c-0.2,15.7-13,28.5-28.8,28.5c-15.9,0-28.8-12.9-28.8-28.8 c0-15.9,12.9-28.8,28.8-28.8C643.6,65.4,656.5,78.3,656.5,94.2L656.5,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.8,120.8c-2.9,1.4-6.2,2.2-9.6,2.2c-12.4,0-22.4-10-22.4-22.4l0,0V65.4h21.8c0,0,3.6-12.7,3.6-28.8h-25.4 V3c-16.1,0-28.8,4.3-28.8,4.3s0,17.3,0,29.4l0,0v63.9c0,0,0,0,0,0.1c0,28.2,22.9,51.1,51.1,51.1c9.7,0,18.7-2.7,26.4-7.4 C223.4,137.8,217.6,129.8,213.8,120.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M582.5,44c-7.7-4.7-16.7-7.4-26.4-7.4c-28.2,0-51.1,22.9-51.1,51.1c0,0,0,0,0,0.1v63.9h28.8V87.8l0,0 c0-12.4,10-22.4,22.4-22.4c3.4,0,6.7,0.8,9.6,2.2C569.6,58.5,575.4,50.5,582.5,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.9,0.6c-8.7,0-15.7,7-15.7,15.7C0.1,25,7.2,32,15.9,32s15.7-7,15.7-15.7C31.6,7.6,24.5,0.6,15.9,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.2,36.7c-28.2,0-51.1,22.9-51.1,51.1c0,0,0,0,0,0.1v63.9h28.8V87.8l0,0c0-12.4,10-22.4,22.4-22.4 s22.4,10,22.4,22.4v63.9h28.8V87.8C143.3,59.5,120.5,36.7,92.2,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.5,151.7h28.8v-115c-16.1,0-28.8,4.3-28.8,4.3V151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.3,151.7h28.8V3c-15.7,0-28.2,4.1-28.7,4.2L340.3,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.2,36.7c-10.5,0-20.3,2.8-28.8,7.7l0-41.4c-15.8,0-28.3,4.1-28.7,4.2c0,0,0,86.9,0,86.9 c0,31.8,25.8,57.5,57.5,57.5s57.5-25.8,57.5-57.5C495.8,62.4,470,36.7,438.2,36.7z M438.2,122.9c-15.9,0-28.8-12.9-28.8-28.8h0V94 c0.1-15.8,12.9-28.6,28.8-28.6c15.9,0,28.8,12.9,28.8,28.8C467,110,454.1,122.9,438.2,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M331.6,107.8c-14.8-5.9-27.8-6.3-27.8-6.3c-3.6,13.9-17,23.2-31.6,21.2c-3.3-0.4-6.3-1.4-9.1-2.8L328.1,70 c-8-17.2-24.4-30.1-44.7-32.8c-31.5-4.2-60.4,18-64.5,49.5c-4.2,31.5,18,60.4,49.5,64.5C297.6,155,324.4,135.5,331.6,107.8 L331.6,107.8z M247.4,90.5c2.1-15.8,16.5-26.8,32.3-24.8c3.3,0.4,6.3,1.4,9.1,2.8L247.8,100C247.2,96.9,247,93.7,247.4,90.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M750,81.8l-18.9,0c-4.5,0-8.2-3.6-8.2-8.2c0-4.5,3.7-8.2,8.2-8.2h41.3c0.2-0.5,4.2-12.9,4.2-28.6 c0,0-44.8,0-47.5,0c-19.3,0-35,15.7-35,35s15.7,35,35,35h18.9c4.5,0,8.2,3.7,8.2,8.2s-3.7,8.2-8.2,8.2h-46.9 c-0.2,0.5-4.2,12.9-4.2,28.6c0,0,52.4,0,53.1,0c19.3,0,35-15.7,35-35C785,97.4,769.3,81.8,750,81.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIntelbrasVerde);
export default __webpack_public_path__ + "static/media/logo-intelbras-verde.64a5e217fe2cb73c2a68f470067cb556.svg";
export { ForwardRef as ReactComponent };